import CopyButton from './CopyButton';

export default function UserMessage({ text }: { text: string }) {
  return (
    <div className="group ml-auto max-w-2xl flex flex-col items-end">
      <div className="bg-primary-600 text-white rounded-2xl rounded-tr-sm px-5 py-3">
        <p className="text-sm leading-relaxed whitespace-pre-wrap break-words">{text}</p>
      </div>
      {/* Copy the question — revealed on hover/focus to keep the bubble clean. */}
      <div className="opacity-0 group-hover:opacity-100 focus-within:opacity-100 transition-opacity mt-0.5">
        <CopyButton text={text} title="Copy question" />
      </div>
    </div>
  );
}
